import { useEffect, useRef, useState } from 'react';
import FastTransferModal from './FastTransferModal';
import { createRegisteredWalletClient } from './registeredWalletPolicy';
import { pendingWalletKey, readPendingWallet } from './fastWalletTransfer';

// The environment selects the 01 service; only the server selects an account's flow.
export default function RegisteredWalletRouter({ LegacyModal, ...props }) {
    const [client] = useState(() => createRegisteredWalletClient());
    const [policy, setPolicy] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [hasPending, setHasPending] = useState(false);
    const alive = useRef(true);
    const locked = useRef(false);
    const load = async () => {
        if (locked.current) return;
        locked.current = true; setLoading(true); setError('');
        try {
            let pending = true;
            try { pending = !!readPendingWallet(pendingWalletKey(process.env.REACT_APP_API, props.mid)); } catch { /* Block legacy if local recovery state is unreadable. */ }
            const next = await client.policy();
            if (alive.current) { setHasPending(pending); setPolicy(next); }
        } catch (e) { if (alive.current) { setPolicy(null); setError(e.message); } }
        finally { locked.current = false; if (alive.current) setLoading(false); }
    };
    const loader = useRef(load); loader.current = load;
    useEffect(() => { alive.current = true; void loader.current(); return () => { alive.current = false; client.clear(); }; }, [client]);
    if (loading) return <div className="modal-backdrop"><div className="modal-sheet" role="dialog" aria-label="출금 정책 확인"><p role="status">출금 정책을 확인하고 있습니다.</p></div></div>;
    if (policy?.supported === false && !hasPending) return <LegacyModal {...props} />;
    return <FastTransferModal {...props} policy={policy} policyError={error} onReloadPolicy={load}
        onPolicy={client.policy} onFunds={client.funds} securityClient={client.security}
        onTransfer={client.withdraw} onQuery={client.query} />;
}
